module.exports = __webpack_public_path__ + "img/radiaIcon0.3d1d966f.svg";